import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Col, Row, Table } from 'react-bootstrap';
import { notify } from 'react-notify-toast';
import moment from 'moment';
import LoadingScreen from '../../Layout/LoadingScreen';
import PaginationBar from '../students/list/PaginationBar';
import { getMpPreferenceLinks } from '../../services/billsService';

const ViewMPLinks = ({ active }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [preferences, setPreferences] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumbers, setPageNumbers] = useState([]);
  const isComponentMounted = useRef(false);
  const requestedPageRef = useRef(1);

  const fetchPreferences = useCallback(
    async (page) => {
      requestedPageRef.current = page;
      setIsLoading(true);
      try {
        const data = await getMpPreferenceLinks(page);
        if (isComponentMounted.current && requestedPageRef.current === page) {
          setPreferences(data.data);
          setCurrentPage(data.currentPage);
          setTotalPages(data.totalPages);
          setPageNumbers(data.pageNumbers);
        }
      } catch (error) {
        notify.show('Hubo un error al obtener las preferencias', 'error');
      } finally {
        if (isComponentMounted.current) {
          setIsLoading(false);
        }
      }
    },
    []
  );

  useEffect(() => {
    isComponentMounted.current = true;
    if (active) {
      fetchPreferences(1);
    }
    return () => {
      isComponentMounted.current = false;
    };
  }, [active, fetchPreferences]);

  const handleNavigate = useCallback(
    (page) => fetchPreferences(page),
    [fetchPreferences]
  );

  return isLoading ? (
    <LoadingScreen />
  ) : (
    <div className='d-flex justify-content-center align-items-center flex-column my-4 pb-5 ml-1 mr-1'>
      <Row>
        <Col lg={12} xs={12}>
          <div className='table-responsive'>
            <Table striped bordered hover variant='dark' className='w-100 pt-5'>
              <thead>
                <tr>
                  <th className='text-center'>Alumno</th>
                  <th className='text-center'>Monto</th>
                  <th className='text-center'>Descripción</th>
                  <th className='text-center'>Tipo de Link</th>
                  <th className='text-center'>Fecha de Creación</th>
                  <th className='text-center'>Usuario que creo el link</th>
                </tr>
              </thead>
              <tbody>
                {preferences.map((preference) => (
                  <tr key={preference._id}>
                    <td className='text-center'>{preference.email}</td>
                    <td className='text-center'>{preference.amount}</td>
                    <td className='text-center text-break'>
                      {preference.description}
                    </td>
                    <td className='text-center'>
                      {preference.external_reference}
                    </td>
                    <td className='text-center'>
                      {moment(preference.createdAt).format('DD/MM/YYYY HH:mm')}
                    </td>
                    <td className='text-center'>{preference.createdBy.name}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
      {totalPages > 1 && (
        <PaginationBar
          pageNumbers={pageNumbers}
          currentPage={currentPage}
          totalPages={totalPages}
          onNavigate={handleNavigate}
        />
      )}
    </div>
  );
};

export default ViewMPLinks;
